




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { repairOrderService } from '@/shared';


@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class RoFollowUpListPage extends Base {

    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public loading: boolean = false;
    public disableSubmitButton: boolean = false;

    public roFollowUp = {
        roNumber: "",

    };


    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'roFollowup');

        this.setFields();
    }

    public setFields(): void {
        this.formFields = [
            {
                key: 'roNumber',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: 'RO Number',
                    validations: '',
                    required: true,
                    disabled: false,
                    loading: false,

                },
            },

        ];
    }



    public async sendFollowUpMessage() {
        if (this.roFollowUp.roNumber == "") {
            this.showAlert(false, 'RO Number is required');
        }
        else {
            try {
                this.formlyShowSkeleton(this.formFields);
                this.disableSubmitButton = true;
                const response = await repairOrderService.PostRoFollowUp(this.roFollowUp.roNumber);
                if (response.success) {
                    this.roFollowUp.roNumber = "";
                    this.showAlert(true, 'Follow Up Message Send Successfully');

                } else {
                    this.showAlert(false, 'RO Number Not Found');
                }
                this.disableSubmitButton = false;
            } finally {
                this.formlyHideSkeleton(this.formFields);
                this.disableSubmitButton = false;
            }
        }

    }


}
